import { isEmpty } from 'lodash';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setTransactionReportFilters } from '../../../store/actions/reportingAndAnalyticsActions';
import DateSwitcher from '../reportingUtils/DateSwitcher';
import { MetricCardGroup } from '../reportingUtils/TransactionCountGuageCard';
import { ReactComponent as InpatientNoDataIcon } from '../../../../src/assets/images/svg/InpatientNoData.svg';
import { DATE_SWITCHER_CONFIG, REPORTING_CONSTANTS, REPORTING_TYPE_CONSTANTS } from '../reportingUtils/reportingAndAnalyticsConstants';
import { TatMetricCardGroup } from '../reportingUtils/TatCountGuage';

const TransactionCountGauge = (props: any): ReactElement => {
  const { getSections, setActiveSection, transactionData, availableStatus, reportType, expandedSections, setExpandedSections } = props;
  const {
    reportingTransactionMeta,
    transactionReportFilters,
    isDateRangeClicked,
  }: any = useSelector(
    (state: RootState): any => state?.reportingAndAnalytics || {},
  );

  const dispatch = useDispatch();
  const handleTabChange = (tab: string): void => {
    dispatch(setTransactionReportFilters({ dateFilter: tab }));
  };

  const displayGuage = (): ReactElement => {
  switch (reportType) {
    case REPORTING_TYPE_CONSTANTS.TRANSACTION_COUNT:
      return (
          <MetricCardGroup
            data={transactionData}
            config={reportingTransactionMeta ?? {}}
            getSections={getSections}
            setActiveSection={setActiveSection}
            availableStatus={availableStatus}
          />
      );

    case REPORTING_TYPE_CONSTANTS.TRANSACTION_TAT:
      return (
          <TatMetricCardGroup
            data={transactionData}
            config={reportingTransactionMeta ?? {}}
            getSections={getSections}
            setActiveSection={setActiveSection}
            availableStatus={availableStatus}
            expandedSections={expandedSections}
            setExpandedSections={setExpandedSections}
          />
      );

    default:
      return <></>;
  }
};

  return (
    <div>
      <div>
        {!isDateRangeClicked && (
          <DateSwitcher
            tabs={DATE_SWITCHER_CONFIG}
            selected={transactionReportFilters?.dateFilter}
            onChange={handleTabChange}
          />
        )}
      </div>
      {isEmpty(transactionData) ? (
        <div className="no-data-wrapper">
          <InpatientNoDataIcon />
          <div>{REPORTING_CONSTANTS.PLEASE_REFINE_YOUR_SEARCH_CRITERIA}</div>
        </div>
      ) : (
        <div>
         {displayGuage()}
        </div>
      )}
    </div>
  );
};

export default TransactionCountGauge;
